import React, { useState, useRef } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Link } from 'react-router-dom';

import './loans.css';


const LeadNamesInGrid = ( { row, contacts } ) => {
    const borrowers = row.borrowers;
    const pri = borrowers.find( b => b.label === 'Primary' );

    const [show, setShow] = useState(false);
    const handleOnMouseEnter = () => {
        setShow( true );
    }
    const handleOnMouseLeave = () => {
        setShow( false );
    }

    const ref = useRef();

    const formatName = ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };

    const popup = (
        <Popover id="popover-basic" style={ { width: '300px', zIndex: '9999' } } onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Popover.Header as="h3">Borrowers</Popover.Header>
            <Popover.Body>
                { 
                    borrowers.map( b => {
                        return (
                            <Row key={b.cid} className='text-start py-1' style={ { fontSize: '12px' } }>
                                <Col className='ps-0'><Link to={`/contact/${b.cid}`}>{formatName( b.cid )}</Link></Col>
                            </Row>
                        )
                    } ) 
                }
            </Popover.Body>
        </Popover>
    );

    return (
        <Container>
            {
                ( borrowers.length > 0 ) ? (
                    <Row className='p-0'>
                        <Col xs='auto' className='p-0 pe-2'><Link to={`/contact/${borrowers[0].cid}`}>{formatName( borrowers[0].cid )}</Link></Col>
                        {
                            ( borrowers.length > 1 ) ? (
                                <OverlayTrigger placement="right" overlay={popup} show={show} container={ref}>
                                    <Col xs='auto' className='tf-multi-borrower-badge ps-1 align-items-center' ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>+{borrowers.length - 1}</Col>
                                </OverlayTrigger>
                            ) : (
                                null
                            )
                        }
                    </Row>
                ) : (
                    null
                )
            }
        </Container>
    )
}

const mapProps = ( state ) => ( {
    // aid: state.user.aid,
    // uid: state.user.email,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( LeadNamesInGrid );